import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { GetApp, Search as SearchIcon } from "@material-ui/icons";
import { Grid, Button, FormControl, InputLabel, Input, IconButton, InputAdornment } from "@material-ui/core";
import { PrimaryButton, ButtonSizeOptions, SecondaryButton, InputText, InputTypeAhead } from '@loanbossinc/component-library';

import Dropdown from "../Global/Dropdown/Dropdown";
import UploadSpreadsheetModal from "./UploadSpreadsheetModal";
import { downloadProperties } from "../../store/state/properties";

const NewButton = styled(Button)`
  && {
    margin: 0 0 -4px 4px;
    padding: 8px 8px 0px 2px;
    border-radius: 0;
    color: #005AA9w;
    background: none;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const VerticalDivider = styled.div`
  height: 24px;
  border-right: 1px solid #cccccc;
`;

const SearchInput = styled(Input)`
  min-width: 240px;
`;

const StyledInputLabel = styled(InputLabel)`
  /* Work Sans / 12 Semibold CAPS */
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;

  /* Text / Dark Gray */
  color: #5F6368;

  border-bottom: '1px solid #DADCE0',
  &&:hover {
    
  border-bottom: '1px solid #DADCE0',
  }
`;

const StyledGrid = styled(Grid)`&&&{
  margin-bottom: 12px;
}`;

const StyledInputText = styled(InputText)`&& {
  width: 400px;
  }`;
class PropertiesHeader extends Component {
  constructor(props) {
    super(props);
    this.state = { isUploadModalOpen: false };
  }

  componentDidUpdate = prevProps => {
    if (!prevProps.uploadSuccessful && this.props.uploadSuccessful) {
      this.setState({ isUploadModalOpen: false });
    }
  };

  onExport = () => {
    const propertyIds = this.props.records.map(record => record.propertyId);
    this.props.downloadProperties(propertyIds);
  };

  render() {
    const { searchName, assetManager, assetManagerList, handleChange } = this.props;
    
    return (
      <>
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={0} style={{ marginTop: "10px", marginBottom: "10px" }}>
          <Grid item xs={12}>
              <Grid item>
                <div className="title-component">Properties</div>
              </Grid>
          </Grid>
          <StyledGrid item xs={6} md={5}>
            <Grid container direction="row" justify="flex-end" alignItems="flex-end" spacing={16}>
              <Grid item xs={6}>

              <InputTypeAhead
                      id= 'assetManager'
                      name= 'assetManager'
                      label= 'Asset Manager'                      
                      options= {assetManagerList}
                      displayWith= {(option) => option && option.name}
                      setValueWith= {(option) => option && option.id}
                      onChange={selectedOption => handleChange("assetManager", selectedOption ? selectedOption : null)}
                      variant={"filled"}
                      className="input" />
              </Grid>
              <Grid item xs={6}>

                <StyledInputText
                      type="search"
                      borderRadius={8}
                      placeholder="Search by Deal or Property"
                      onChange={({ target }) => handleChange("searchName", target.value)}
                      variant={"filled"}
                      value={searchName}
                      InputProps={{ startAdornment: <SearchIcon /> }}/>
              </Grid>
            </Grid>
          </StyledGrid>
          <StyledGrid item xs={6} md={7}>
            <Grid container direction="row" justify="flex-end" alignItems="flex-end" spacing={16}>
              <Grid item>
                <SecondaryButton
                    label="UPDATE"
                    onClick={() => this.setState({ isUploadModalOpen: true })}
                    size={ButtonSizeOptions.smFluid}
                  />
              </Grid>
              <Grid item>
                <PrimaryButton
                  label="EXPORT"
                  onClick={this.onExport}
                  size={ButtonSizeOptions.smFluid}
                />
              </Grid>
            </Grid>
          </StyledGrid>
        </Grid>
        <UploadSpreadsheetModal
          selectedPropertyIds={this.props.records.map(record => record.propertyId)}
          onClose={() => this.setState({ isUploadModalOpen: false })}
          isOpen={this.state.isUploadModalOpen}
        />
      </>
    );
  }
}

const mapStateToProps = ({ properties }) => ({
  uploadSuccessful: properties.uploadSuccessful
});

PropertiesHeader.propTypes = {
  searchName: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  assetManager: PropTypes.object.isRequired,
  assetManagerList: PropTypes.array.isRequired,
  records: PropTypes.array.isRequired
};

export default connect(mapStateToProps, { downloadProperties })(PropertiesHeader);
